/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-03-09 16:30:27
 * @LastEditors: kai.zhou
 * @LastEditTime: 2020-06-12 16:52:36
 */

import React from "react";
import { HashRouter as Router } from "react-router-dom";
import { renderRoutes } from "assets/renderRouter";
import Loadable from "react-loadable"; //按需加载路由插件

const MyLoadingComponent = (v: { isLoading: any; error: any }) => {
  if (v.isLoading) {
    return <div>Loading...</div>;
  } else if (v.error) {
    return <div>Sorry, there was a problem loading the page.</div>;
  } else {
    return null;
  }
};
const Landing = Loadable({
  loader: () => import("../views/landing"),
  loading: MyLoadingComponent,
});
const Record = Loadable({
  loader: () => import("./record"),
  loading: MyLoadingComponent,
});
const Rules = Loadable({
  loader: () => import("./rules"),
  loading: MyLoadingComponent,
});

const routes = [
  {
    path: "/landing", //落地页
    component: Landing,
  },
  {
    path: "/record", //老首页
    component: Record,
  },
  {
    path: "/rules", //老首页
    component: Rules,
  },
  {
    path: "/",
    redirect: "/landing",
  },
];

const mRoute = () => {
  return <Router>{renderRoutes(routes)}</Router>;
};

export default mRoute;
